import { getUploadedSubcategoryMedia } from '../../../helpers/SubcategoryMedia'
import React, { useState, useEffect, useContext } from 'react'
import {
    Form,
    Button,
    Row,
    Col,
    Input,
    Card,
    CardBody,
    FormGroup,
    Label
} from 'reactstrap'

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context'
import { withRouter } from 'react-router-dom'
import Select from 'react-select'
import { isEmpty } from 'lodash'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext
    const { data: loadedData } = props

    const [categoryId, setCategoryId] = useState()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [image, setImage] = useState('')
    const [imagePath, setImagePath] = useState('')
    const [categories, setCategories] = useState([])

    useEffect(() => {
        (async () => {
            await fetchCategories()

            async function fetchCategories() {
                setLoading(true)
                const response = await ApiService.getCategories()
                let data = []

                response.data.data.map((item) => {
                    return data.push({
                        value: item.id,
                        label: item.name,
                    })
                })

                setLoading(false)
                setCategories(data)
            }
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        if (!isEmpty(loadedData)) {
            setName(loadedData.name)
            setDescription(loadedData.description)
            setImage(loadedData.image)
            setImagePath(loadedData.imagePath || '')
        }

    }, [loadedData])

    useEffect(() => {
        if (!isEmpty(categories) && props.data?.categoryId !== undefined) {
            setCategoryId(categories.find(i => i.value === props.data.categoryId))
        }
    }, [categories, props.data?.categoryId]) // eslint-disable-line

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')

            return
        }

        const data = {
            categoryId: categoryId.value,
            name,
            description,
            image,
            imagePath
        }

        setLoading(true)
        if (props.data !== undefined) { 
            data.id = props.data.id
            const response = await ApiService.updateSubcategory(data).catch(error => {
                toastr.error('No pude editar esta subcategoría', 'Error')
            })

            if (response.data.success) {
                toastr.success('Edité una subcategoría', '¡Éxito!')
            }

            setLoading(false)
            return
        }

        const response = await ApiService.createSubcategory(data).catch(error => {
            toastr.error('No pude agregar esta subcategoría', 'Error')
        })

        if (response.data.success) {
            toastr.success('Agregué una subcategoría', '¡Éxito!')
        }

        setLoading(false)
        _clearForm()
    }

    const _validateForm = () => {
        if (name === '') { return false }

        return true
    }

    const _clearForm = () => {
        setName('')
        setImage('')
        setImagePath('')
        setDescription('')

        document.getElementById('name').focus()
    }

    const _handleFileUpload = (event) => {
        let files = event.target.files
        const types = ['image/png', 'image/jpeg', 'image/gif']

        if (types.every(type => files[0].type !== type)) {
            toastr.error('Solo se aceptan imagenes', 'Error')

            return 
        }
        setLoading(true)
        fileUpload(files[0]).then((response) => {
            const media = getUploadedSubcategoryMedia(response.data)
            setImage(media.image)
            setImagePath(media.imagePath)
            setLoading(false)
            toastr.success('Subí la imagen', '¡Éxito!')
        }).catch(error => {
            console.log('fileUpload', error)
            setLoading(false)
            toastr.error('No pude subir la imagen', 'Error')
        })
    }

    const fileUpload = (file) => {
        const formData = new FormData()
        formData.append('file', file)

        return ApiService.uploadSubcategoryImage(formData)
    }

    return(
        <React.Fragment>
            <Form id="create" method="POST" onSubmit={ handleSubmit }>
                <Row>
                    <Col xs={12}>
                        <Card style={{textAlign: 'right'}}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-primary btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label className="control-label">
                                                Categoría *
                                            </Label>

                                            <Select
                                                id="categoryId"
                                                value={categoryId}
                                                options={categories}
                                                placeholder={`Selecciona una categoría`}
                                                onChange={value => setCategoryId(value)}
                                                />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>
                                                Nombre *
                                            </Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                value={name}
                                                id="name"
                                                onChange={event => setName(event.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="name">
                                                Descripción
                                            </Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                value={description}
                                                onChange={event => setDescription(event.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>Imagen</Label>

                                            <Input type="file"
                                                id="image"
                                                onChange={ _handleFileUpload }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default withRouter(FormPage)
